import React from "react";
import Select from "react-select";

const promptAlpha0 = `## **Yêu cầu bài viết**:
- **Từ khóa chính**: {danh sách từ khoá,..}
- **Giọng điệu**: {tone bài viết}
- **Độ dài**: {số lượng từ trên bài viết}
- **Cấu trúc bài viết**:
1. **Tiêu đề hấp dẫn** (tối đa 15 từ, có chứa từ khóa chính và năm hiện tại 2025)
2. **Đoạn mở bài thu hút** (giới thiệu vấn đề, hứa hẹn giá trị)
3. **Nội dung chính** (chia thành các tiêu đề phụ H2, H3 để dễ đọc)
4. **Kết luận** (tóm tắt và kêu gọi hành động)`;
const prompt = [
    {
        label: "Prompt mẫu",
        options: [
            { value: '', label: "Prompt hệ thống" },
            { value: promptAlpha0, label: "Prompt mode alpha .0" },
            { value: "đang cập nhật..", label: "Prompt mode alpha .2" },
        ],
    },
];

const PromptTemplateSelect = ({ onChange }:any) => {
    const handleChange = (selectedOption:any) => {
        if (!selectedOption) return;

        // Tìm group label tương ứng
        onChange(selectedOption.value || "");
    };

    return (
        <div className="mb-4">
            <Select
                options={prompt}
                defaultValue={prompt[0].options[0]}
                onChange={handleChange}
                placeholder="chọn prompt mẫu"
                isSearchable
                className="text-sm"
                styles={{
                    container: (base) => ({
                        ...base,
                        width: 200, // hoặc '280px'
                    }),
                }}
            />
        </div>
    );
};

export default PromptTemplateSelect;
